var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardListSection',_vm._b({staticClass:"c-frontpage-themes",attrs:{"id":("c-frontpage-themes-" + (_vm.$vnode.key)),"is-gray":false,"show-link-at-bottom":""}},'CardListSection',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }